import { Routes, Route, Navigate } from 'react-router-dom';
import { DashboardPage } from '@/pages/dashboard';
import { ProjectsPage } from '@/pages/projects';
import { ProjectDetailsPage } from '@/pages/project-details';
import { PortfolioPage } from '@/pages/portfolio';
import { UtilisationPage } from '@/pages/utilisation';
import { WIPReportingPage } from '@/pages/wip-reporting';
import { ProfitabilityPage } from '@/pages/profitability';
import { BudgetsPage } from '@/pages/budgets';
import { ResourcesPage } from '@/pages/resources';
import { DirectoryPage } from '@/pages/directory';
import { RolesRatesPage } from '@/pages/roles-rates';
import { GanttPage } from '@/pages/gantt';
import { SettingsPage } from '@/pages/settings';
import { SettingsProjectsPage } from '@/pages/settings-projects';
import { SettingsBudgetConfigurationPage } from '@/pages/settings-budget-configuration';
import { UserPreferencesPage } from '@/pages/user-preferences';
import CategoryManagement from '@/pages/category-management';
import { ProjectCreationSetup } from '@/pages/project-creation-setup';
import { ErrorHandlingDemoPage } from '@/pages/error-handling-demo';
import { ColumnConfiguratorDemo } from '@/pages/column-configurator-demo';
import { ResponsiveTableDemo } from '@/pages/responsive-table-demo';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/projects/:projectId" element={<ProjectDetailsPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/utilisation" element={<UtilisationPage />} />
      <Route path="/wip-reporting" element={<WIPReportingPage />} />
      <Route path="/profitability" element={<ProfitabilityPage />} />
      <Route path="/budgets" element={<BudgetsPage />} />
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/directory" element={<DirectoryPage />} />
      <Route path="/roles-rates" element={<RolesRatesPage />} />
      <Route path="/gantt" element={<GanttPage />} />
      <Route path="/feature-labs" element={<Navigate to="/settings?tab=feature-labs" replace />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/projects" element={<SettingsProjectsPage />} />
      <Route path="/settings/projects/budget-configuration" element={<SettingsBudgetConfigurationPage />} />
      <Route path="/user-preferences" element={<UserPreferencesPage />} />
      <Route path="/category-management" element={<CategoryManagement />} />
      <Route path="/project-creation-setup" element={<ProjectCreationSetup />} />
      <Route path="/error-handling-demo" element={<ErrorHandlingDemoPage />} />
      <Route path="/column-configurator-demo" element={<ColumnConfiguratorDemo />} />
      <Route path="/responsive-table-demo" element={<ResponsiveTableDemo />} />
      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

// Route path constants for easy reference
export const ROUTES = {
  DASHBOARD: '/dashboard',
  PROJECTS: '/projects',
  PROJECT_DETAILS: (projectId: number) => `/projects/${projectId}`,
  PORTFOLIO: '/portfolio',
  UTILISATION: '/utilisation',
  WIP_REPORTING: '/wip-reporting',
  PROFITABILITY: '/profitability',
  BUDGETS: '/budgets',
  RESOURCES: '/resources',
  DIRECTORY: '/directory',
  ROLES_RATES: '/roles-rates',
  GANTT: '/gantt',
  FEATURE_LABS: '/feature-labs',
  SETTINGS: '/settings',
  SETTINGS_PROJECTS: '/settings/projects',
  SETTINGS_PROJECTS_BUDGET_CONFIGURATION: '/settings/projects/budget-configuration',
  USER_PREFERENCES: '/user-preferences',
  CATEGORY_MANAGEMENT: '/category-management',
  PROJECT_CREATION_SETUP: '/project-creation-setup',
  ERROR_HANDLING_DEMO: '/error-handling-demo',
  COLUMN_CONFIGURATOR_DEMO: '/column-configurator-demo',
  RESPONSIVE_TABLE_DEMO: '/responsive-table-demo',
} as const;
